//
// Imports
//

import * as BrowserUtilities from "@donutteam/browser-utilities";
import { initialiseForm } from "@donutteam/document-builder-components/src/client.js";

import { RequestBody, ResponseBodySchema } from "../../../../api/routes/v6/profiles/update.schemas.js";

//
// Component
//

export function initialiseAboutForm(aboutForm: HTMLFormElement)
{
	const apiUrl = BrowserUtilities.ElementClientLib.getStringDataOrThrow(aboutForm, "apiUrl"); 

	const aboutSyntaxSelect = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLSelectElement>(aboutForm, `select[name="aboutSyntax"]`);

	const aboutTextTextarea = BrowserUtilities.ElementClientLib.getElementOrThrow<HTMLTextAreaElement>(aboutForm, `textarea[name="aboutText"]`);

	initialiseForm(aboutForm,
		async () =>
		{
			const requestBody: RequestBody =
			{
				aboutSyntax: Number(aboutSyntaxSelect.value),
				aboutText: aboutTextTextarea.value,
			};

			const response = await fetch(apiUrl + "/v6/profiles/update",
				{
					credentials: "include",
					method: "POST",
					headers:
					{
						"Content-Type": "application/json",
					},
					body: JSON.stringify(requestBody),
				});

			const responseBody = ResponseBodySchema.parse(await response.json());

			if (!responseBody.success)
			{
				return {
					restoreInputs: true,
					notices: responseBody.errors.map((error) => ({ type: "warning", message: error.message, dismissible: true })),
				};
			}

			return {
				restoreInputs: true,
				notices: [ { type: "success", message: "Your about has been updated successfully.", dismissible: true } ],
			};
		});

	aboutForm.classList.add("initialised");
}

export function initialiseAboutForms()
{
	const aboutForms = document.querySelectorAll<HTMLFormElement>(".component-about-form:not(.initialised)");

	console.log("[AboutForm] Initialising " + aboutForms.length + " instances...");

	for (const aboutForm of aboutForms)
	{
		try
		{
			initialiseAboutForm(aboutForm);
		}
		catch (error)
		{
			console.error("[AboutForm] Error initialising:", aboutForm, error);
		}
	}
}